import pageRegistryJson from './page-registry.json';

type PageRegistryItem = {
    component: string;
    icon: string;
    path: string;
    title: string;
    inMenu: boolean;
    lastmod: string | null;
    isStub?: boolean;
};
const PageRegistryItemType = pageRegistryJson as PageRegistryItem[];
export const serviceItems = PageRegistryItemType.filter(
    (item) => item.inMenu && !item.isStub,
);
